import { useQuery, useMutation } from '@tanstack/react-query';
import { createProject, deleteProject, getProject, updateProject } from '../../apis/project_management/Loadallprojectmanagement';

// Use Project
export const useProject = (
  start_limit: number,
  pagination_size: number,
  itemto_order: string,
  desorasc: string,
  search_term: string,
  user_role_id: number,
  user_designation: number
) => useQuery({
  queryKey: ['project', start_limit, pagination_size, itemto_order, desorasc, search_term, user_role_id, user_designation],
  queryFn: () => getProject(start_limit, pagination_size, itemto_order, desorasc, search_term, user_role_id, user_designation),
  staleTime: 5 * 60 * 1000, // 5 minutes
});

// Add Project
export const useAddProject = (projectAdded: any) => useMutation({
  mutationFn: () => createProject(projectAdded)
});

// Delete Project
export const useDeleteProject = (projectToDelete: number) => useMutation({
  mutationFn: () => deleteProject(projectToDelete)
});

// Update Project
export const useUpdateProject = (projectToUpdate: any) => useMutation({
  mutationFn: () => updateProject(projectToUpdate)
});
